import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import CaseStudyHero from '../../components/hero3/casestudyhero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Scrollbar from '../../components/scrollbar/scrollbar'

const Testimonials = (props) => { 
        return (
            <Fragment>
                 <div className='index_business_consulting'>
                    <main className="page_content s2">
                        <Header3 />
                        <CaseStudyHero top_title={<>What Our Clients <br/> Say</>} top_desp={<>Ready to get started? Contact us now for a free <br/> consultation and let’s bring your ideas to life. Don’t <br/>  wait!</>} />

                        <section className="intro_about_section section_space">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="review-card">
                                            <div className="stars">★★★★★</div>

                                            <div className="review-details">
                                                <div className="row">
                                                <span>Quality:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Schedule:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Cost:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Willing to Refer:</span><span>5.0</span>
                                                </div>
                                            </div>

                                            <div className="review-box" style={{ background: "#fff9dc" }}></div>
                                            <div className="review-box" style={{ background: "#dedede" }}></div>

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>

                                            {/* <div className="learn-more">
                                                Learn More &rarr;
                                            </div> */}
                                        </div>


                                        <div className="review-card">
                                            <div className="review-box" style={{ background: "#dedede" }}></div>

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>
                                        </div>

                                        <div className="review-card">
                                            <div className="stars">★★★★★</div>

                                            <div className="review-details">
                                                <div className="row">
                                                <span>Quality:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Schedule:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Cost:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Willing to Refer:</span><span>5.0</span>
                                                </div>
                                            </div>

                                            <div className="review-box" style={{ background: "#fff9dc" }}></div>
                                            <div className="review-box" style={{ background: "#dedede" }}></div>

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>

                                            {/* <div className="learn-more">
                                                Learn More &rarr;
                                            </div> */}
                                        </div>

                                    </div>

                                    <div className="col-lg-4">
                                        <div className="review-card">
                                            <div className="review-box" style={{ background: "#dedede" }}></div>

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>
                                        </div>
                                        <div className="review-card">
                                            <div className="stars">★★★★★</div>

                                            <div className="review-details">
                                                <div className="row">
                                                <span>Quality:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Schedule:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Cost:</span><span>5.0</span>
                                                </div>
                                                <div className="row">
                                                <span>Willing to Refer:</span><span>5.0</span>
                                                </div>
                                            </div>

                                            <div className="review-box" style={{ background: "#fff9dc" }}></div>
                                            <div className="review-box" style={{ background: "#dedede" }}></div>

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>

                                            {/* <div className="learn-more">
                                                Learn More &rarr;
                                            </div> */}
                                        </div>

                                        <div className="review-card">
                                            <div className="review-box" style={{ background: "#dedede" }}></div>

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>
                                        </div>

                                        <div className="review-card">

                                            <div className="priority">
                                                Our priority, and we appreciate the opportunity to address any issues and ensure your complete satisfaction.
                                            </div>

                                            <div className="user-info">
                                                Jennie Kim<br />
                                                <span className="designation">Designation, Company</span><br />
                                                <span className="location">USA</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        <BusinessContact />
                        <BusinessFooter />
                        <Scrollbar />

                    </main>
                </div>
            </Fragment>
        )
};

export default Testimonials;